import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from "@mui/material";
import React from "react";
import Input from "react-phone-number-input/input";
export const PhoneInput = ({ id, name, label, placeholder, required, fullWidth, error, value, onChange, disabled, ...props }) => {
    return (_jsx(Input
    // @ts-ignore
    , { 
        // @ts-ignore
        inputComponent: InnerInput, value: value, onChange: newValue => {
            onChange(newValue || "");
        }, ...props, id: id, name: name, label: label, placeholder: placeholder, required: required, fullWidth: fullWidth, error: error, disabled: disabled }));
};
/*
A custom inputComponent can be passed to render it instead of the standard DOM <input/>.
It must behave as a standard DOM <input/>: support ref, accept a string value, and call onChange(event) whenever it's changed.
 */
const InnerInput = React.forwardRef(({ disabled, error, required, fullWidth, label, variant, ...props }, forwardedRef) => {
    return (_jsx(TextField, { disabled: disabled, error: Boolean(error), helperText: error ?? undefined, inputRef: forwardedRef, label: label, required: required, fullWidth: fullWidth, variant: variant, slotProps: {
            htmlInput: { disabled, required, ...props },
        } }));
});
//# sourceMappingURL=PhoneInput.js.map